import Loading from '@kaidam/fc-shared/src/frontend/components/system/Loading'
export default Loading